import { FC } from 'react';
import { legacyLozingsvormen } from '@/lib/types/relatie';
import { LozingsvormBase } from '../lozingsvorm-base';

interface Properties {
  teeltwijze: number;
}

export const LozingsvormV2: FC<Properties> = ({ teeltwijze }) => <LozingsvormBase teeltwijze={teeltwijze} values={legacyLozingsvormen} />;
